module.exports = __webpack_public_path__ + "static/media/YM79_4.b123cb7d.jpg";